<template>
    <div class="about-seven-section" v-if="about != null">
        <div class="container">
            <div class="about-seven-park">
                <div class="column-container">
                    <div class="col-left">
                        <div class="park-img">
                            <img :src="about.img_park" alt="">
                        </div>
                    </div>
                    <div class="col-right">
                        <div class="section-title">
                            <h5>{{about.upper_title_park}}</h5>
                            <h2>{{about.title_park}}</h2>
                        </div>
                        <div class="desc">
                            <p v-for="desc in about.desc_park">{{desc.text}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="about-seven-estet">
                <div class="column-container">
                    <div class="col-left">
                        <div class="section-title">
                            <h5>{{about.upper_title_estet}}</h5>
                            <h2>{{about.title_estet}}</h2>
                        </div>
                        <div class="desc">
                            <p v-for="desc in about.desc_estet">{{desc.text}}</p>
                        </div>
                        <!-- <div class="btn-open-estet-modal">
                            <a href="#" @click.prevent="openModalInit">
                                {{about.btn_title}}
                            </a>
                        </div> -->
                    </div>
                    <div class="col-right">
                        <div class="estet-img">
                            <img :src="about.img_estet" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <!-- модалка -->
            <modal name="about-seven-estet-modal" :transition="transitionName" :width="modalWidth" :height="modalHeight" :scrollable="true" id="about-seven-estet-modal" v-if="modalData != 0">
                <div class="modal-content">
                    <button class="btn-close-seven-estet--modal" @click="closeAboutSevenModal()"><svg-icon icon-class="close" className="icon-close"/></button>
                    <div class="estet-full-img">
                        <img :src="modalData" alt="">
                    </div>
                </div>
            </modal>
            <!-- end -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'about-seven-second',
        components: {
        },
        data () {
            return {
                modalWidth: '',
                modalHeight: '',
                transitionName: '',
                modalData: ''
            }
        },
        computed: {
            about() {
                return this.$store.state.about.about_seven_elem
            }
        },
        methods: { 
            openModalInit() {
                this.$modal.show('about-seven-estet-modal');
            },
            closeAboutSevenModal() {
				this.$modal.hide('about-seven-estet-modal');
			},
            settingsFlatsCardModal() {
                this.modalData = this.about.img_concept;
				var _self = this;
				if ($(window).width() > 1024) {
					_self.modalWidth = 1000;
					_self.modalHeight = 640;
					_self.transitionName = 'fade-enter'
				} else {
					_self.modalWidth = 100;
					_self.modalHeight = 'auto';
					_self.transitionName = 'fade-enter'
				}
			},
			handleResize() {
                var _self = this;
                if (window.innerWidth >= 1024) {
                    _self.modalWidth = 1000;
					_self.modalHeight = 640;
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        created () {
        },
        mounted () {
            this.$store.watch(
				(state) => state.about,
				(newValue) => {
					if (newValue) {
						this.settingsFlatsCardModal();
                        this.checkResize();
					}
				}
			)
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/about/about-elems/about-elem-seven.scss';
    @import '@/styles/components/animation/animation-about-seven.scss';
    @import '@/styles/components/about/about-media/7-media.scss';
</style>